module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_7005.6ae8c15d.png";